import React from 'react';
import './onboarding-dialog.css';

export interface IOnboardingDialogBaseProps {
	title: React.ReactNode;
	badgeText?: string;
	stepText?: string;
	buttonText?: string;
	onAcknowledge: () => void;
	children: React.ReactNode;
	wide?: boolean;
}

export const OnboardingDialogBase: React.FC<IOnboardingDialogBaseProps> = ({
	title,
	badgeText,
	stepText,
	buttonText = 'Acknowledge',
	onAcknowledge,
	children,
	wide = false,
}) => {
	return (
		<div className="onboarding-dialog-overlay">
			<div className={`onboarding-dialog-card ${wide ? 'onboarding-dialog-card--wide' : ''}`}>
				{badgeText && (
					<div className="onboarding-badge">
						<span className="onboarding-badge-dot" />
						{badgeText}
					</div>
				)}
				<h2 className="onboarding-dialog-title">{title}</h2>
				<div className="onboarding-dialog-body">
					{children}
				</div>
				<button className="onboarding-acknowledge-btn" onClick={onAcknowledge}>
					{buttonText}
				</button>
				{stepText && (
					<div className="onboarding-step-text">
						{stepText}
					</div>
				)}
			</div>
		</div>
	);
};
